import { render, staticRenderFns } from "./UploadCreatives.vue?vue&type=template&id=11a4fe07"
import script from "./UploadCreatives.vue?vue&type=script&lang=js"
export * from "./UploadCreatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports